module.exports = __webpack_public_path__ + "static/vitaclub-9f28753f8ea2fe8cd23ce3453971fbe3.png";